import { useState, useContext } from 'react'
import { arcadeApiClient } from '../apiClients'
import { AuthContext, AppContext } from '../providers'
import { Reaction } from 'types/Reaction'
import { showVibePointsToast } from 'components/VibePointsToast/showVibePointsToast'
import { mutateMyVibePoints, mutateVibeLeaderboard } from './useVibePoints'

export const useReactions = (
  itemId: number,
  itemType: 'NewsfeedItem' | 'Comment',
  itemReactions: Reaction[],
  gameId?: number,
) => {
  const { auth } = useContext(AuthContext)
  const { setToast } = useContext(AppContext)
  const [reactions, setReactions] = useState<Reaction[]>(itemReactions || [])

  const onReact = (chosenReaction: string) => {
    const reaction = reactions.find(
      reaction =>
        reaction.user.id === auth.id && reaction.reaction === chosenReaction,
    )

    if (reaction) {
      return deleteReaction(reaction)
    } else {
      return addReaction(chosenReaction)
    }
  }

  const deleteReaction = (reaction: Reaction) =>
    arcadeApiClient
      .delete(`/multi_platform/reactions/${reaction.id}`)
      .then(() => {
        setReactions(prevReactions =>
          prevReactions.filter(_reaction => _reaction.id !== reaction.id),
        )
      })

  const addReaction = (chosenReaction: string) =>
    arcadeApiClient
      .post('/multi_platform/reactions', {
        reaction: {
          reaction: chosenReaction,
          reactable_id: itemId,
          reactable_type: itemType,
        },
      })
      .then(response => {
        setReactions(prevReactions => [...prevReactions, response.data])
        showVibePointsToast(response.data.vibePointsEarned, setToast)
        if (gameId) {
          mutateMyVibePoints(gameId)
          mutateVibeLeaderboard(gameId)
        }
      })

  return { reactions, onReact }
}
